import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { SubmitButton } from '../lib/Button';
import dashboard from './dashboard';
import { ActionHeader } from './dashboard/makeNct';
import { Dialog, Divider } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { validatePanForAmfiCas } from '../redux-store/actions/link';
import { useDispatch } from 'react-redux';
import en from '../lang/en-us';
/*************  ✨ Codeium Command ⭐  *************/
/**
 * AMFICAS is a React component that displays a confirmation message
 * when the user requests an RTA CAS.
 *
 * @param {object} props The component props.
 * @returns {ReactElement} A React element representing the component.
 */
/******  d23da9ba-ee2e-418e-a649-dada67d8c039  *******/ 

const {
    login: { quickLinks, applyPan, form: LoginForm },
    signUp: { form: SignupForm },
} = en;
function AMFICAS() {
    const location = useLocation();
    const history = useHistory();
    const queryParams = location.search;

    const parsedQueryParams = new URLSearchParams(queryParams);

    const token = parsedQueryParams.get('token');

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);

    useEffect(() => {
        async function callApi() {
            await validatePanForAmfiCas({
                reqId: "",
                encryptRequest: token,
            })(dispatch);
        }
        callApi().catch((error: any) => {
            alert(error.message);
        });
    }, [token]);
    return (
        <div className="curved-bg quick-links-content">
            <div className="curved-bg-inner">
                <div className="curved-bg-content request-box">
                    <div className="curved-bg-content-inner">
                        <div className="curved-bg-content-inner-top">
                            <div className="request-box-content">
                                <div className="request-box-mail-mobile" style= {{ marginBottom: '20px'}}>
                                    <img
                                        src="/images/Send-Mail.svg"
                                        alt="icon"
                                    />
                                </div>
                                <div className="request-box-text-content">
                                    <p>
                                        We have successfully received your request for the RTA CAS.
                                        An email attached with your CAS will be sent to the
                                        registered email address linked to your folio within the
                                        next 15 minutes.
                                    </p>
                                </div>
                                <div className="request-box-mail">
                                    <img
                                        src="/images/Send-Mail.svg"
                                        alt="icon"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="journey-today">
                    <div className="journey-today-header">
                        <h3>Start your Investment Journey Today</h3>
                    </div>
                    <Divider orientation="horizontal" color="#FFF"/>
                    <div className="journey-today-content" style={{ marginLeft: '20px' }}>
                        <p>
                            MF Central is an investor services hub developed by KFintech and CAMS,
                            designed to streamline transactions across all your folios with ease.
                        </p>
                        <div className="journey-today-button">
                            <Button onClick={() => {
                                history.push('/');
                            }}>Visit MF Central</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="quick-links">
                <div className="quick-links-header">
                    <p>Quick Links</p>
                </div>
                <div className="quick-link-blocks update-pan">
                    <img src="/images/update-pan-1.svg" alt="icon" />
                    <p style={{ cursor: 'pointer' }} onClick={() => {
                        history.push('/links/update-pan');
                    }}>Update PAN</p>
                </div>
                <div className="quick-link-blocks apply-pan">
                    <img src="/images/apply-pan-1.svg" alt="icon" />
                    <p style={{ cursor: 'pointer' }} onClick={() => {
                        setShow(true);
                    }}>Apply for PAN</p>
                </div>
                <div className="quick-link-blocks tranmission-request">
                    <img src="/images/trans-request.svg" alt="icon" />
                    <p style={{ cursor: 'pointer' }} onClick={() => {
                        history.push('/links/transmission-request');
                    }}>Transmission Request</p>
                </div>
                <div className="quick-link-blocks rupee">
                    <img src="/images/rupee.svg" alt="icon" />
                    <p style={{ cursor: 'pointer' }} onClick={() => {
                        history.push('/links/transfer-of-units');
                    }}>Transfer of units</p>
                </div>
                <div className="quick-link-blocks mitra">
                    <img src="/images/mitra.svg" alt="icon" />
                    <p style={{ cursor: 'pointer' }} onClick={() => {
                        history.push('/links/inactive-folios');
                    }}>MITRA</p>
                </div>
            </div>
            <Dialog fullWidth maxWidth={'md'} open={show} aria-labelledby="applyPanModal">
                <div className="applyPanModal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">{applyPan.heading}</h4>
                                <a onClick={() => setShow(!show)}>
                                    <img src="/images/close-black.svg" alt="icon" />
                                </a>
                            </div>
                            <div className="modal-body">
                                <h6>{applyPan.info}</h6>
                                <h6>{applyPan.infoBottom}</h6>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment.svg"
                                        alt="icon"
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/nsdl.png" alt="icon" />
                                    </div>
                                    <p>NSDL</p>
                                    <a
                                        href="https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment2.svg"
                                        alt="icon"
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/utiitsl.png" alt="icon" />
                                    </div>
                                    <p>UTIITSL</p>
                                    <a
                                        href="https://www.pan.utiitsl.com/PAN/mainform.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-info">
                                    <p>
                                        {applyPan.websiteInfo}{' '}
                                        <a
                                            href="https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx"
                                            target="_blank"
                                        >
                                            https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx
                                        </a>{' '}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
export default AMFICAS;
